/* This file contains the feature flag names. Feature flag is required to 
manage the incomplete feature codes segregated from the rest. */

export const CLAIM_LICENSE = "claim_license" //
export const PROFILE_DUPLICATE = "profile_duplicate" // EDCL-214
export const IG_USER_MANAGEMENT = "ig_user_management" // EDCL-181
export const RX_ZS = "rxlogger_zebrastorage" // EDCL-123
export const CONTROL_APP_UNINSTALL = "controll_app_uninstall" // EDCL-123
export const EHS = "enterprise_home_screen" // EDCL-33
export const DEVICE_USERS_CREATED_ON_FILTER = "device_users_created_on_filter" // EDCL-883
export const DEVICE_USER_LOGIN_HISTORY = "device_user_login_history" // EDCL-915
export const PENDO_TRACKING = "pendo_tracking" // EDCL-1025
export const IG_DEVICE_USER_ENROLLMENT = "ig_device_user_enrollment" // EDCL-293
export const ZEBRA_STORAGE_LICENSE = "zebra_storage_license" // Zebra Storage License feature - EDCL-681
export const SSO_ENABLED = "sso_enabled" // EDCL-700
export const VALIDATE_USER_LOGIN = "validate_user_login" // EDCL-702
export const ZEBRA_STORAGE_SECURE_FILE_MGMT = "file_management_secure_link" // EDCL-350 (RS)
